import type { z } from 'zod';

export const validateDateRange = (
	fromDate: Date | null | undefined,
	toDate: Date | null | undefined,
	errorMessage: string | undefined,
	ctx: z.RefinementCtx,
	toPath: string,
) => {
	const isFromDateLaterThanToDate = fromDate && toDate && fromDate > toDate;

	if (isFromDateLaterThanToDate) {
		return ctx.addIssue({
			code: 'custom',
			message: errorMessage,
			path: [toPath],
		});
	}
};
